"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLanguage = exports.AppEnvironment = void 0;
var app_environment_enum_1 = require("./app-environment.enum");
Object.defineProperty(exports, "AppEnvironment", { enumerable: true, get: function () { return app_environment_enum_1.AppEnvironment; } });
var app_language_enum_1 = require("./app-language.enum");
Object.defineProperty(exports, "AppLanguage", { enumerable: true, get: function () { return app_language_enum_1.AppLanguage; } });
